import React from 'react';

const NameDetail = ({ name }) => (
  <div className="w-full">
    <span>{name}</span>
  </div>
);

export default NameDetail;
